(function ($) {
  'use strict';

  $(function () {

    var products = window.SK_PRODUCTS || {};
    var totalSteps = $('.dh-step:not(#dh-result)').length;
    var scores = { 'sugar-knocker': 0, 'berberine-advanced': 0, 'herbal-tea': 0, 'metabolic-kit': 0 };

    /* ---------- Progress ---------- */
    function setProgress(stepIndex) {
      var pct = Math.max(10, Math.round((stepIndex / totalSteps) * 100));
      $('#dh-progress-bar').css('width', pct + '%');
      $('#dh-progress-label').text('Question ' + (stepIndex + 1) + ' of ' + totalSteps);
    }

    /* ---------- Show step ---------- */
    function showStep(index) {
      $('.dh-step').removeClass('active');
      var $step = $('#dh-step-' + index);
      if ($step.length) {
        $step.addClass('active').removeAttr('hidden');
        setProgress(index);
      }
    }

    /* ---------- Option selection ---------- */
    $(document).on('click', '.dh-option', function () {
      var $opt = $(this);
      var step = parseInt($opt.data('step'), 10);
      var $group = $opt.closest('.dh-options');
      $group.find('.dh-option').removeClass('selected');
      $opt.addClass('selected');
      $('#dh-step-' + step + ' .dh-next').prop('disabled', false);
    });

    /* ---------- Next ---------- */
    $(document).on('click', '.dh-next', function () {
      var step = parseInt($(this).data('step'), 10);
      var $selected = $('#dh-step-' + step + ' .dh-option.selected');
      if (!$selected.length) return;

      /* accumulate weights */
      var weights = $selected.attr('data-weights');
      try {
        var w = JSON.parse(weights);
        $.each(w, function (key, val) {
          if (scores.hasOwnProperty(key)) scores[key] += val;
        });
      } catch (e) {}

      var nextStep = step + 1;
      if (nextStep < totalSteps) {
        showStep(nextStep);
      } else {
        showResult();
      }
    });

    /* ---------- Back ---------- */
    $(document).on('click', '.dh-back', function () {
      var step = parseInt($(this).data('step'), 10);
      showStep(step - 1);
    });

    /* ---------- Show result ---------- */
    function showResult() {
      $('#dh-progress-bar').css('width', '100%');
      $('#dh-progress-label').text('Your result');

      /* find top product */
      var best = null;
      var bestScore = -1;
      $.each(scores, function (key, val) {
        if (val > bestScore) { bestScore = val; best = key; }
      });

      var prod = products[best];
      if (!prod) return;

      /* result card */
      var $card = $('#dh-result-card');
      $card.html(
        '<div class="dh-result-card__img-wrap">' +
          '<img src="' + $('<div>').text(prod.img).html() + '" alt="' + $('<div>').text(prod.name).html() + '" class="dh-result-card__img">' +
        '</div>' +
        '<div class="dh-result-card__body">' +
          '<span class="dh-result-card__tag" style="background:' + prod.tagBg + '">' + $('<div>').text(prod.tag).html() + '</span>' +
          '<h3 class="dh-result-card__name">' + $('<div>').text(prod.name).html() + '</h3>' +
          '<p class="dh-result-card__fit">' + $('<div>').text(prod.fit).html() + '</p>' +
          '<div><span class="dh-result-card__price">' + $('<div>').text(prod.price).html() + '</span> ' +
          '<span class="dh-result-card__per">' + $('<div>').text(prod.per).html() + '</span></div>' +
        '</div>'
      );

      $('#dh-result-note').text('Our quiz matched you with ' + prod.name + ' based on your preferences. This is a recommendation, not a prescription - see the full product page for ingredients, suggested usage and safety notes before ordering.');
      $('#dh-result-buy').attr('href', prod.route).text('Order ' + prod.name);
      $('#dh-result-know').attr('href', prod.route).text('See Full Details');

      /* alternates */
      var $alts = $('#dh-result-alts').empty();
      $.each(products, function (key, p) {
        if (key === best) return;
        var $a = $('<a></a>').addClass('dh-result-alt').attr('href', p.route);
        $('<img>').addClass('dh-result-alt__img').attr({ src: p.img, alt: p.name }).appendTo($a);
        $('<span>').text(p.name).appendTo($a);
        $alts.append($a);
      });

      $('.dh-step').removeClass('active');
      $('#dh-result').addClass('active').removeAttr('hidden');
    }

    /* ---------- Restart ---------- */
    $('#dh-restart').on('click', function () {
      scores = { 'sugar-knocker': 0, 'berberine-advanced': 0, 'herbal-tea': 0, 'metabolic-kit': 0 };
      $('.dh-option').removeClass('selected');
      $('.dh-next').prop('disabled', true);
      $('#dh-result').removeClass('active').prop('hidden', true);
      showStep(0);
    });

    /* ---------- Compare card image hover ---------- */
    $('.sk-offer-card__img').each(function () {
      var $img = $(this);
      var $card = $img.closest('.dh-compare-card');
      $card.on('mouseenter', function () { if ($img.data('hover-src')) $img.attr('src', $img.data('hover-src')); });
      $card.on('mouseleave', function () { if ($img.data('src')) $img.attr('src', $img.data('src')); });
    });

    /* Init */
    showStep(0);

  });
})(jQuery);
